import { bamboo, blade, cloud, figure, gust, leaf, slash, speed, swirl, sword } from '../kit';
import { C, mix, type Pix } from '../pix';
import { registerIcons } from '../store';

/** กระบี่ไผ่ห่มหมอก (บู๊ตึ๊ง, soft): a jade-hilted sword, wind curls, bamboo and reeds. */

const HILT = C.jade;
const WIND = '#c8fff0';
const LEAF = '#7ad86a';

const breezeSword = (p: Pix, x0: number, y0: number, x1: number, y1: number) =>
  sword(p, x0, y0, x1, y1, { hilt: HILT, tassel: '#7af0c8' });

registerIcons('skill', {
  // The sword with the breeze curling round its blade.
  'bs-gust': (p) => {
    breezeSword(p, 5, 27, 26, 6);
    gust(p, 3, 12, 11, WIND);
    gust(p, 14, 22, 11, WIND, false);
    gust(p, 17, 6, 6, WIND);
  },
  // A thrust through a cloud, which parts round the point.
  'bs-cloud': (p) => {
    cloud(p, 13, 15, 17, '#e8f4f8');
    p.rect(13, 10, 18, 2, mix(WIND, C.ink, 0.35));
    speed(
      p,
      9,
      [
        [6, 6],
        [15, 7],
      ],
      WIND,
    );
    breezeSword(p, 2, 11, 30, 11);
  },
  // Bamboo leaves whirled round the caster.
  'bs-sweep': (p) => {
    slash(p, 16, 16, 13, -0.4, 4.6, WIND, 2);
    for (let k = 0; k < 6; k++) {
      const a = (k * Math.PI) / 3 + 0.3;
      leaf(
        p,
        16 + Math.cos(a) * 9,
        16 + Math.sin(a) * 9,
        -Math.sin(a),
        Math.cos(a),
        7,
        k % 2 ? LEAF : '#a8f08a',
      );
    }
    p.ell(16, 16, 2.5, 2.5, C.white);
  },
  // Green bamboo breathing out a slow curl of qi.
  'bs-bamboo': (p) => {
    bamboo(p, 13, 29, 6, '#5cc04a');
    bamboo(p, 21, 29, 10, '#7ad85a');
    swirl(p, 17, 17, 9, WIND, { arms: 2, turn: 3 });
  },
  // Gliding forward on the wind, sword leading.
  'bs-glide': (p) => {
    speed(
      p,
      13,
      [
        [12, 9],
        [17, 11],
        [22, 8],
      ],
      WIND,
    );
    figure(p, 12, 10, C.white, 'leap', { head: C.skin });
    blade(p, 19, 13, 29, 9, { w: 2, col: C.steel });
    gust(p, 6, 26, 14, WIND, false);
  },
  // A veil of mist drawn round the body.
  'bs-mist': (p) => {
    figure(p, 14, 9, mix(HILT, C.white, 0.3), 'stand', { head: C.skin });
    for (const [y, x, l] of [
      [12, 6, 20],
      [17, 4, 24],
      [22, 6, 21],
      [27, 9, 16],
    ] as const)
      for (let i = 0; i < l; i++)
        p.px(x + i, y + Math.round(Math.sin((x + i) / 2.2)), i % 4 === 3 ? WIND : '#e8f8ff');
  },
  // Reeds bowing to the wind, three cuts through them.
  'bs-reed': (p) => {
    for (const [x, h] of [
      [7, 20],
      [12, 23],
      [17, 19],
      [22, 22],
    ] as const) {
      p.line(x, 29, x + 4, 29 - h, '#b8c87a');
      p.rect(x + 3, 29 - h, 2, 4, '#d8b070');
    }
    for (let k = 0; k < 3; k++)
      p.thick(4 + k * 3, 21 - k * 6, 28 + k * 0, 12 - k * 6, k === 1 ? C.white : WIND, 1);
  },
  // A tempest: a funnel of wind with swords flung round it.
  'bs-tempest': (p) => {
    for (let k = 0; k < 7; k++) {
      const y = 6 + k * 3;
      const rx = 12 - k * 1.4;
      p.ring(16 + Math.sin(k) * 1.5, y, rx, 1.6, k % 2 ? WIND : C.white, 0, Math.PI * 2);
    }
    blade(p, 4, 12, 10, 7, { w: 2, col: C.steel });
    blade(p, 27, 16, 22, 22, { w: 2, col: C.steel });
    leaf(p, 24, 6, 1, -0.3, 5, LEAF);
    leaf(p, 6, 23, -1, 0.4, 5, LEAF);
  },
});
